import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-60ad0f4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate channel-header-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "animate profile-name" }
const _hoisted_4 = { class: "animate reputation-card" }
const _hoisted_5 = { class: "animate profile-image-container" }
const _hoisted_6 = { class: "animate profile-image" }
const _hoisted_7 = { class: "animate profile-data-container" }
const _hoisted_8 = {
  class: "animate profile-data",
  style: {"background-color":"#333"}
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import SocialProfileImage from '@/components/widgets/SocialProfileImage.vue';
import ReputationCardUsers from '@/components/widgets/ReputationCardUsers.vue';
import ChannelService from '@/services/ChannelService';
import ProfileService from '@/services/ProfileService';
import { ref, onMounted } from 'vue'
import { useAuth } from '@/store/useAuth';
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import FollowChannelButton from '@/components/widgets/FollowChannelButton.vue'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelHeader',
  props: ['user'],
  setup(__props) {

const channelService = new ChannelService()
const user = ref()
const loading = ref(true)
const profileService = new ProfileService()
const store = useAuth()
const showEditNickname = ref(false)
const nickname = ref('')
const toast = useToast()
const bg = ref()
const showUpdateBG = ref(false)
const feedback = ref('')
const followers = ref('cargando...')
const following = ref('cargando...')
const props = __props

onMounted(async () => {
    loading.value = true
    setTimeout(async () => {
        try {
    followers.value = await channelService.CountFollowers(props.user.id)
    following.value = await channelService.CountFollowing(props.user.id)
    }
    catch(e) {
        console.log('Error while fetching counts', e);
    }
    }, 2000);
    loading.value = false
})


return (_ctx: any,_cache: any) => {
  return (props.user && !loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (props.user.profile_bg_uri)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: props.user.profile_bg_uri,
              class: "bg-image"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, _toDisplayString(props.user.name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ReputationCardUsers, {
            user_id: props.user.id
          }, null, 8, ["user_id"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(SocialProfileImage, {
              user: props.user
            }, null, 8, ["user"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (props.user.nickname)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_9, "@" + _toDisplayString(props.user.nickname), 1))
                : (_openBlock(), _createElementBlock("h5", _hoisted_10, "@" + _toDisplayString(props.user.name.substring(0, 3) + props.user.id), 1))
            ]),
            (props.user.nickname)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "animate profile-data",
                  style: {"cursor":"pointer"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name: 'followers-list', params: {nickname: props.user.nickname}})))
                }, [
                  _createElementVNode("h5", null, "Seguidores: " + _toDisplayString(followers.value), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "animate profile-data",
                  style: {"cursor":"pointer"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({name: 'followers-list', params: {nickname: props.user.name.substring(0, 3) + props.user.id}})))
                }, [
                  _createElementVNode("h5", null, "Seguidores: " + _toDisplayString(followers.value), 1)
                ])),
            (props.user.nickname)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "animate profile-data",
                  style: {"cursor":"pointer"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({name: 'following-list', params: {nickname: props.user.nickname}})))
                }, [
                  _createElementVNode("h5", null, "Siguiendo: " + _toDisplayString(following.value), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "animate profile-data",
                  style: {"cursor":"pointer"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push({name: 'following-list', params: {nickname: props.user.name.substring(0, 3) + props.user.id}})))
                }, [
                  _createElementVNode("h5", null, "Siguiendo: " + _toDisplayString(following.value), 1)
                ])),
            _createVNode(FollowChannelButton, {
              user_id: props.user.id
            }, null, 8, ["user_id"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})